import React from "react";
import mainImage from "../assets/omni.jpg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useUser } from "@/store/useUser";
import VideoModal from "../components/modals/VideoModal";
import { useModal } from "../context2/ModalContext";

const TwoColumnSection: React.FC = () => {
  const { openModal } = useModal();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useUser();

  return (
    <section
      className="relative w-full max-w-full mx-auto px-4 sm:px-6 lg:px-[10%]
    grid md:grid-cols-2 gap-4 md:gap-10 lg:gap-10 items-center 
    text-center md:text-left
  "
    >
      {/* Left Side - Image */}
      <div className="flex justify-center md:justify-start w-full">
        <img src={mainImage} className="rounded-lg max-w-full h-auto" />
      </div>

      {/* Right Side - Text + Button */}
      <div className="w-full flex flex-col gap-3 md:gap-4 items-center md:items-start">
        <h2 className="font-bold text-4xl sm:text-5xl text-black">
          {t("line_01")} <span className="text-purple-600">{t("line_02")}</span>{" "}
          {t("line_03")}
        </h2>
        <p className="leading-relaxed text-lg text-gray-500">
          {t("line_04")}{" "}
          <span className="text-xl font-medium">{t("line_05")}</span>
        </p>
        <div className="md:flex md:space-y-0   space-y-2 flex-1 gap-2 col-span-2 justify-center md:justify-start w-full">
          {!user && (
            <button
              onClick={() => {
                if (Cookies.get("auth_token")) {
                  navigate("/content");
                } else {
                  navigate("/auth");
                }
              }}
              className="group w-48 py-2.5 font-semibold rounded-md bg-[#764EE3] hover:text-[#7650e3] border border-[#7650e3] hover:bg-[#d7d7fc] text-white transition"
            >
              <span>{user ? t("create_post") : t("get_started_free")}</span>
              &nbsp;
              <span className="inline-block transform transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </button>
          )}
          {!user && (
            <button
              onClick={() => openModal(VideoModal)}
              className="group w-48 py-2.5 border border-[#7650e3] text-[#7650e3]  font-semibold rounded-md hover:bg-purple-100 transition"
            >
              <span>{t("How_to_use")}</span>&nbsp;
              <span className="inline-block transform transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </button>
          )}
          {user && (
          <button
            onClick={() => {
              if (Cookies.get("auth_token")) {
                navigate("/content");
              } else {
                navigate("/auth");
              }
            }}
            className="group w-48 py-2.5 border border-purple-600 text-purple-600 font-semibold rounded-md hover:bg-purple-100 transition"
          >
            <span>{user ? t("create_post") : t("get_started_free")}</span>{" "}
            &nbsp;
            <span className="inline-block transform transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default TwoColumnSection;
